import React, { useState, useLayoutEffect, useEffect } from "react";
import { ResponsiveDrawer } from "./navbar";
import { Cards } from "./card";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
// import Inventory from "./inventory/Inventory";
import NoAccess from "./NoAccess";
import CashDetails from "./fast cash/CashDetails";
import Vendors from "./vendors/Vendors";
import Racks from "./racks/Racks";
import RackDetails from "./racks/RackDetails";
import CustomerReport from "./reports/CustomerLedgerReport";
import Reports from "./reports/Reports";
import EmployeeSalary from "./salary/EmployeeSalary";
import SalaryHistory from "./salary/SalaryHistory";
import Inventory from "./inventory/Inventory";
import CompanyProfile from "./company profile/CompanyProfile";
import Bills from "./bills/Bills";
import WarehouseBills from "./WarehouseBills";
import UpdateBill from "./bills/UpdateBill";
import SellItem from "./point of sale/Sell";
import Quotations from "./quotation/Quotations";
import QuotationDetail from "./quotation/QuotationDetails";
import dailyBook from "./daybook/dailyBook";
import OutPurchase from "./purchaseOrders/OutPurchase";
import UpdateOrder from "./purchaseOrders/UpdatePurchase";
import PurchaseOrders from "./purchaseOrders/index";
import FinalizedOrders from "./purchaseOrders/FinalizedOrders";
import PurchaseOrdersReturn from "./returnedfinalizedOrders";
import Invoices from "./invoice/Invoices";
import AddInvoice from "./invoice/AddInvoice";
import LedgersList from "./ledgers/LedgersList";
import LedgerDetails from "./ledgers/LedgerDetails";
import VouchersList from "./vouchers/VouchersList";
import Warehouses from "./warehouses/Warehouses";
import WarehouseDetail from "./warehouses/WarehouseDetail";
import FastCash from "./fast cash/FastCash";
import Payment from "../pages/payment";
// import Inventory from "./inventory/Inventory";
import axios from "axios";
import NotFound from "./NotFound";
import { useDispatch, useSelector } from "react-redux";
import SaleReturn from "./saleReturn/saleReturnOrders";
import SelectItems from "./point of sale/SelectItems";
import Summary from "./summary/Summary";

function Dashboard({ lang }) {
  const { company } = useSelector((state) => state.company);

  const token = localStorage.getItem("token");
  if (token == null || localStorage.getItem("tokenType") != "user") {
    return <Redirect to="/inventory" />;
  }

  let features = [];
  if (company?.featuresAccess) {
    features = company.featuresAccess;
  }
  console.log("features", features);

  const cardUrls = features.reduce((acc, item) => {
    acc[item.url] = item.url;
    return acc;
  }, {});
  console.log("urls", cardUrls);
  return (
    <React.Fragment>
      <Router>
        <div className="appgrid component-background">
          <div>
            <ResponsiveDrawer lang={lang} />
          </div>
          <div>
            <Switch>
              <Route
                exact
                path="/inventory/dashboard/"
                component={() => <Cards lang={lang} />}
              />

              <Route exact path="/" component={() => <Cards lang={lang} />} />
              <Route
                exact
                path="/inventory/"
                component={() => <Cards lang={lang} />}
              />
            
              <Route
                exact
                path="/inventory/purchase-order/finalized"
                component={FinalizedOrders}
              />
              <Route
                exact
                path="/inventory/dashboard/dashboard"
                component={() => <Cards lang={lang} />}
              />

              <Route
                exact
                path="/inventory/dashboard/fastcash"
                component={cardUrls["fastcash"] ? FastCash : NoAccess}
              />
             
              <Route
                exact
                path="/inventory/dashboard/payment"
                component={cardUrls["payment"] ? Payment : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/fastcash/details"
                component={cardUrls["fastcash"] ? CashDetails : NoAccess}
              />

              <Route
                exact
                path="/inventory/dashboard/vendor"
                component={cardUrls["vendor"] ? Vendors : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/racks"
                component={cardUrls["racks"] ? Racks : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/rack-details"
                component={cardUrls["racks"] ? RackDetails : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/report/customer-report"
                component={cardUrls["report"] ? CustomerReport : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/report"
                component={cardUrls["report"] ? Reports : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/employee-salary"
                component={
                  cardUrls["employee-salary"] ? EmployeeSalary : NoAccess
                }
              />

              <Route
                exact
                path="/inventory/dashboard/salary-history"
                component={
                  cardUrls["employee-salary"] ? SalaryHistory : NoAccess
                }
              />

              <Route
                exact
                path="/inventory/dashboard/summary"
                component={cardUrls["summary"] ? Summary : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/items"
                component={cardUrls["items"] ? Inventory : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/sale-returns"
                component={cardUrls["sale-returns"] ? SaleReturn : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/outgoing"
                component={cardUrls["outgoing"] ? SelectItems : NoAccess}
              />

              <Route
                exact
                path="/inventory/dashboard/employees"
                component={NoAccess}
              />

              <Route
                exact
                path="/inventory/dashboard/bills"
                component={cardUrls["bills"] ? Bills : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/roll-items"
                // component={cardUrls["roll-items"]? RollItems : NoAccess}
                component={NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/warehouse-bills"
                component={WarehouseBills}
              />
                <Route
                exact
                path="/inventory/admin/bills/update-bill"
                component={cardUrls["bills"] ? UpdateBill : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/bills/update-bill"
                component={cardUrls["bills"] ? UpdateBill : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/outgoing/sell"
                component={cardUrls["outgoing"] ? SellItem : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/scanning"
                component={cardUrls["scanning"] ? SellItem : NoAccess}
              />

              <Route
                exact
                path="/inventory/dashboard/quotations"
                component={cardUrls["quotations"] ? Quotations : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/quotations/quotation-detail"
                component={cardUrls["quotations"] ? QuotationDetail : NoAccess}
              />

              <Route
                exact
                path="/inventory/dashboard/daybook"
                component={cardUrls["daybook"] ? dailyBook : NoAccess}
              />

              <Route
                exact
                path="/inventory/dashboard/outgoing/outgoingpurchase"
                component={cardUrls["purchase-order"] ? OutPurchase : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/purchase-order/updatedOrder"
                component={cardUrls["purchase-order"] ? UpdateOrder : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/purchase-order"
                component={
                  cardUrls["purchase-order"] ? PurchaseOrders : NoAccess
                }
              />
              <Route
                exact
                path="/inventory/admin/purchase-order/finalized"
                component={
                  cardUrls["purchase-order"] ? FinalizedOrders : NoAccess
                }
              />
              <Route
                exact
                path="/inventory/dashboard/purchase-order/returned=purcahaseorders"
                component={
                  cardUrls["purchase-order"] ? PurchaseOrdersReturn : NoAccess
                }
              />

              <Route
                exact
                path="/inventory/dashboard/invoices"
                component={cardUrls["invoices"] ? Invoices : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/add-invoice"
                component={cardUrls["invoices"] ? AddInvoice : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/ledgers"
                component={cardUrls["ledgers"] ? LedgersList : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/ledgers-details/:id"
                component={cardUrls["ledgers"] ? LedgerDetails : NoAccess}
              />

              <Route
                exact
                path="/inventory/dashboard/vouchers"
                component={cardUrls["vouchers"] ? VouchersList : NoAccess}
              />

              <Route exact path="/inventory/dashboard" component={Dashboard} />
              <Route
                exact
                path="/inventory/dashboard/myshops"
                component={cardUrls["myshops"] ? Warehouses : NoAccess}
              />
              <Route
                exact
                path="/inventory/dashboard/warehouse-detail"
                component={cardUrls["myshops"] ? WarehouseDetail : NoAccess}
              />
              <Route path="/*" component={NotFound} />
            </Switch>
          </div>
          <div></div>
        </div>
      </Router>
    </React.Fragment>
  );
}

export default Dashboard;
